export const FLIGHT_STATUS = ["Belum", "Dalam Proses", "Selesai"];
// 'Terupload' hanya bisa dicapai DARI 'Disetujui' (satu arah, ditegakkan di UI Grids) dan hanya
// menambah informasi — pemodelan yang sudah disetujui tetap dihitung selesai di backend.
export const GRID_STATUS = ["Belum", "Dalam Proses", "Submit", "Revisi", "Disetujui", "Terupload"];
export const PREPROCESSING_STATUS = ["Belum", "Selesai"];
export const SUBMIT_STATUS = ["Belum", "Terupload"];
// Status Control Point. Dua nilai saja, dan ini satu-satunya yang menggerakkan komponen
// realisasi "Akuisisi CP" — cacah 'Sudah Terukur' dibagi seluruh CP.
export const CP_STATUS = ["Belum Terukur", "Sudah Terukur"];
// Jenis titik kontrol: GCP = Ground Control Point, ICP = Independent Check Point.
// 'Belum Ditentukan' di indeks 0 — sama dengan CP_TIPE di node-backend/constants.js — supaya
// options[0] di form berarti "belum diisi". Dua berkas ini wajib sinkron: tidak ada CHECK di DB.
export const CP_TIPE = ["Belum Ditentukan", "GCP", "ICP"];

// Akuisisi kini angka 0-100 berdesimal. Tiga label ini yang dipakai seragam oleh badge tabel,
// opsi filter, dan warna peta — supaya "0 = belum, 1-99 = dalam proses, 100 = selesai" cuma
// didefinisikan sekali.
export const PERSEN_STATUS = ["Belum", "Dalam Proses", "Selesai"];
export const persenLabel = (n) =>
  n === null || n === undefined || n === "" ? null : Number(n) >= 100 ? "Selesai" : Number(n) > 0 ? "Dalam Proses" : "Belum";

export const STATUS_COLOR = {
  Selesai: "#10B981",
  Disetujui: "#10B981",
  Terukur: "#10B981",
  Terverifikasi: "#10B981",
  Baik: "#10B981",
  Terupload: "#0EA5E9",
  "Dalam Proses": "#F59E0B",
  Submit: "#0EA5E9",
  Revisi: "#EF4444",
  Rusak: "#EF4444",
  Belum: "#64748B",
  "Belum Terukur": "#64748B",
  // `Terukur` di atas adalah kosakata lama; `Sudah Terukur` yang dipakai modul Tabular CP sekarang.
  "Sudah Terukur": "#10B981",
  // Tipe CP: dua warna berbeda supaya GCP dan ICP bisa dibedakan sekilas di badge tabel.
  // 'Belum Ditentukan' sebenarnya sudah jatuh ke abu-abu lewat fallback colorOf, tapi dicatat
  // eksplisit di sini supaya terbaca sebagai pilihan warna, bukan kebetulan.
  "Belum Ditentukan": "#64748B",
  GCP: "#0EA5E9",
  ICP: "#F59E0B",
  "Belum Terverifikasi": "#64748B",
};

// Menerima label status maupun angka persen (kolom `percent`, mis. di Dashboard).
export const colorOf = (s) => STATUS_COLOR[typeof s === "number" ? persenLabel(s) : s] || "#64748B";

export const fmtDate = (d) =>
  d ? new Date(`${d}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "—";
